import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { Button, styled, ButtonPropsSizeOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';
import React from 'react';

import WsColors from '../../WsColors';

const StyledButton = styled(Button)({
  color: WsColors.TheBlues400,
  textTransform: 'none',
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: WsColors.TheBlues900,
  },
});

export interface IArrowButton {
  onClick?: React.MouseEventHandler;
  title: string;
  size?: OverridableStringUnion<'small' | 'medium' | 'large', ButtonPropsSizeOverrides>;
}

const ArrowButton: React.FC<IArrowButton> = ({ onClick, title, size = 'medium' }) => (
  <StyledButton size={size} startIcon={<ArrowBackOutlinedIcon />} onClick={onClick}>
    {title}
  </StyledButton>
);

export default ArrowButton;
